// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DebitCardV2DebitCardDetailDefaultResponseData {
    static getAttributeTypeMap() {
        return DebitCardV2DebitCardDetailDefaultResponseData.attributeTypeMap;
    }
}
DebitCardV2DebitCardDetailDefaultResponseData.discriminator = undefined;
DebitCardV2DebitCardDetailDefaultResponseData.additionalProperties = false;
DebitCardV2DebitCardDetailDefaultResponseData.attributeTypeMap = [
    {
        "name": "vdcNumber",
        "baseName": "vdcNumber",
        "type": "string"
    },
    {
        "name": "vdcCvc",
        "baseName": "vdcCvc",
        "type": "string"
    },
    {
        "name": "vdcZip",
        "baseName": "vdcZip",
        "type": "string"
    },
    {
        "name": "last4",
        "baseName": "last4",
        "type": "string"
    },
    {
        "name": "effectiveDate",
        "baseName": "effectiveDate",
        "type": "Date"
    },
    {
        "name": "expirationDate",
        "baseName": "expirationDate",
        "type": "Date"
    },
    {
        "name": "balance",
        "baseName": "balance",
        "type": "number"
    },
];
//# sourceMappingURL=debitCardV2DebitCardDetailDefaultResponseData.js.map